/* V2 */
import * as React from "react";
import {connect} from "react-redux";
import AppUtils, { scrollElementToTop } from "../utils/AppUtils";
import {AppMessages, QuestionType} from "../utils/AppConstants";
import {OngoingConsultationActions} from "../actions/OngoingConsultationActions";
import {isEmpty as _isEmpty} from "lodash";
import ToggleButtonList from "./ToggleButtonList";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import {EventNames, SectionContext} from "../utils/EventTrackerConstants";
import {Tracker} from "../utils/Tracker";

interface TextInputDispatchProps {
    orionClientLogger: (err: any) => void;
}

export interface TextInputProps {
    name?: string;
    widgetName?: string;
    id?: any;
    customRef?: (dom: any) => void;
    isPasswordField?: boolean;
    label?: string;
    customClasses?: string;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, meta: any) => void;
    onChangeCallbackMeta?: any;
    placeholder?: string;
    value?: string|number;
    error?: string;
    style?: any;
    onFocusHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlurHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyUpHandler?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyDownHandler?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onClickHandler?: (event: React.MouseEvent<HTMLInputElement>, data?: {inputType: string, inputValue?: string | number}) => void;
    additionalInformation?: string;
    errorText?: string;
    getClassName?: string;
    validationText?: string;
    type?: string,
    suggestions?: string[]
    keyStrokeEvent?: boolean
    maxLength?: number,
    keyName?: string
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>

interface TextInputState {
    noOfStroke: number
}

type Props = DispatchProps & TextInputProps

const setCaretPosition = (element: any, caretPos: number) => {
    let elem = element;

    if (elem != null) {
        if (elem.createTextRange) {
            let range = elem.createTextRange();
            range.move("character", caretPos);
            range.select();
        }
        else {
            if (elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}

class TextInput extends React.Component<TextInputProps & TextInputDispatchProps, TextInputState> {

    constructor(props: TextInputProps & TextInputDispatchProps) {
        super(props);
        this.state = {
            noOfStroke: 0
        }
    }

    static contextType = SectionContext; // registering context type

    static defaultProps: Partial<Props> = {
        keyStrokeEvent: true
    }

    logError = (value: any) => {
        if (AppUtils.isDefined(value) && !AppUtils.containsOnlyAsciiChar(value)) {
            this.props.orionClientLogger({
                message: AppMessages.ERROR_SPECIAL_CHARACTERS,
                value,
                id: this.props.name
            })
        }
    };

    handleSuggestionSelect = (value: string) => {
        const eventAlias = {target: {value: value}} as React.ChangeEvent<HTMLInputElement>
        this.props.onChange(eventAlias, null)
    }

    scrollToTop = (inputElement: HTMLElement) => {
        if (AppUtils.getIsMobile()) {
            scrollElementToTop(
                inputElement,
                document.querySelector(
                    ".ongoing-consultation-cont"
                ) as HTMLElement,
                60);
        }
    }


    onFocusHandler = (event: any) => {
        this.scrollToTop(event.target);
        this.props.onFocusHandler !== undefined ? this.props.onFocusHandler(event) : "";
    }

    onBlur = (event: any) => {
        const noOfStroke = this.state.noOfStroke
        if (this.props.keyStrokeEvent && noOfStroke) {
            const value = event && event.target && event.target.value
            this.setState({ noOfStroke: 0 })
            Tracker.track(EventNames.KeyStroke, { value: value, field: this.props.name, noOfKeystrokes: noOfStroke, widget: this.props.widgetName, section: this.context });
        }
        this.props.onBlurHandler !== undefined ? this.props.onBlurHandler(event) : "";
    }

    onKeyUp = (event: any) => {
         this.props.onKeyUpHandler !== undefined ? this.props.onKeyUpHandler(event) : "";
    }

    onKeyDown = (event: any) => {
        this.setState({ noOfStroke: this.state.noOfStroke + 1}, () =>  this.props.onKeyDownHandler !== undefined ? this.props.onKeyDownHandler(event) : "")
    }

    onClick = (event: any, data?: {inputType: string, inputValue?: string}) => {
         this.props.onClickHandler !== undefined ? this.props.onClickHandler(event, {inputValue: this.props.value, inputType: "Text", ...data}) : "";
    }

    handleSuggestionClick = (event: any, value: string) => {
        this.onClick(event, {inputType: "Tags", inputValue: value})
    }

    render() {
        let inputRef: any;
        const {props} = this;
        const hasOnlyAsciiChar = AppUtils.containsOnlyAsciiChar(props.value);
        // const specialCharacters = !hasOnlyAsciiChar ? AppUtils.getSpecialCharacters(props.value.toString()) : "";
        let errorClass = (props.error && props.error.length > 0) || !hasOnlyAsciiChar ? "has-error" : "";
        let customClasses = !_isEmpty(props.customClasses) ? props.customClasses : "";
        let type = props.isPasswordField !== undefined ? "password" : !_isEmpty(props.type) ? props.type : "text";
        const updatedValue = AppUtils.isDefined(props.value)
            ? !hasOnlyAsciiChar
                ? AppUtils.getNonSpecialCharString(props.value + "")
                : props.value
            : "";
        const suggestions: IStaticDataValue[] = (this.props.suggestions || []).map((item: string) => ({displayValue: item, internalValue: item}))
        return (
            <div className={"text-input " + errorClass}>
                {!_isEmpty(suggestions) && <div className={"cs-suggestions-container"}>
                    <ToggleButtonList keyName={this.props.keyName} widgetName={this.props.widgetName} type={QuestionType.BOOLEAN_TOGGLE} handleTagsClick={this.handleSuggestionClick} listItems={suggestions} selectedItems={[]} onSelectionChange={this.handleSuggestionSelect}/>
                </div>}
                {props.label && <label className="text-input-label" htmlFor={props.name}>{props.label}</label> }
                <div className="field">
                    <input
                        autoComplete="off"
                        type={type}
                        ref={(dom) => {
                            inputRef = dom;
                            props.customRef !== undefined ? props.customRef(dom) : null
                        }}
                        disabled={props.disabled}
                        name={props.name}
                        placeholder={props.placeholder ? props.placeholder : ""}
                        className={`input-box ${this.props.getClassName ? this.props.getClassName : ""}  ${customClasses}`}
                        value={updatedValue}
                        style={props.style}
                        onChange={(event: any) => {
                            if (props.onChange !== undefined) {
                                let caretPosition = event.target.selectionStart;
                                let value = AppUtils.getNonSpecialCharString(event.target.value);
                                this.logError(value);
                                // if (value.length === 1) value = value.toUpperCase();
                                // else if (value.length > 1) value = value.split(" ").map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
                                //     .split(".").map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(".");

                                event.target.value = value;
                                setCaretPosition(inputRef, caretPosition);
                                props.onChange(event, props.onChangeCallbackMeta)
                            }
                            // props.onChange !== undefined ? props.onChange(event, props.onChangeCallbackMeta) : "";
                        }}
                        onFocus={this.onFocusHandler}
                        onBlur={this.onBlur}
                        onKeyUp={this.onKeyUp}
                        onKeyDown={this.onKeyDown}
                        onClick={this.onClick}
                        maxLength={this.props.maxLength}
                    />
                    {props.error && <div className="alert alert-danger">{this.props.error}</div>}
                </div>
                {
                    props.additionalInformation !== undefined &&
                    <div className={"additional-information"}>{props.additionalInformation}</div>
                }
                {
                    (!_isEmpty(props.validationText)) && <span className={"erroneous-text"}>{props.validationText}</span>
                }
            </div>
        )
    }
};

const mapDispatchToProps = (): TextInputDispatchProps => {
    return {
        orionClientLogger: (err: any) => {
            return OngoingConsultationActions.clientLogger(err);
        }
    }
};

export default connect<void, TextInputDispatchProps, TextInputProps>(
  null,
  mapDispatchToProps
)(TextInput);
